<template src="./index.html"></template>
<script>
import { Search, PullRefresh } from "vant";
import { mapState } from "vuex";
import LostPage from "@/components/LostPage";
import DownScrollLoad from "@/utils/DownScrollLoad";
import SelfTabbar from '@/components/SelfTabbar';
import ManualHelp from "@/components/ManualHelp_APP";
import CouponsPopup from "@/components/CouponsPopup";
import MerchantsDay20210312 from '@/components/MerchantsDay20210312_APP';
export default {
  name: "CustomerMessage",
  components: { Search, PullRefresh, LostPage, SelfTabbar, MerchantsDay20210312, ManualHelp, CouponsPopup},
  data() {
    return {
      HasData: true, // 默认有数据
      isLoading: false,
      DataListDone: false,
      TabbarActive: 0,
      ww_nick: "",
      contentShow: false,
      lostShow: false,
      userInfo: {},
      noRootShow: false,
      scrollValue: 0,
    };
  },
  computed: {
    ...mapState({
      offset:(state)=>{
        return state.CustomerMessage.offset;
      },
      getMessagelist: (state) => {
        return state.CustomerMessage.getMessagelist;
      },
      messageListLength: (state) => {
        return state.CustomerMessage.messageListLength;
      },
      scrollTopValue: (state) => {
        return state.CustomerMessage.scrollTopValue;
      },
      getSappMenuInfo: (state) => {
        return state.Public.getSappMenuInfo;
      },
    }),
  },
  methods: {

    
    scrollEvent(e) {
      this.scrollValue = e.srcElement.scrollTop
      this.$store.commit("CustomerMessage/SET_DATA", {
        key: "scrollTopValue",
        data: this.scrollValue,
      });
      if (e.srcElement.scrollHeight - (e.srcElement.scrollTop + e.srcElement.clientHeight) < 100 ) {
        this.getData({ offset: this.offset, ww_nick: this.ww_nick });
      }
    },



    jump_search_page() {
      // 跳转
      this.$router.push({ name: "CustomerMessageSearchPage",params: {active: "focus"}});
    },
    onRefresh() {
      this.DataListDone = false
      this.$store.commit('CustomerMessage/offset_set',1);
      this.getData({ offset: 1, ww_nick: this.ww_nick });
      this.$store.dispatch('Public/getSappMenuInfo',{});
    },
    jump_ChatRoom(item, index) {
      if (
        this.getSappMenuInfo.customer_message_num > 0 &&
        item.is_exist_xunread != 0
      ) {
        this.getSappMenuInfo.customer_message_num = parseFloat(this.getSappMenuInfo.customer_message_num) - parseFloat(item.is_exist_xunread);
        item.is_exist_xunread = 0;
      }
      this.getMessagelist[index] = item;
      this.$store.dispatch("Public/inH5Record", {
        btn_name: "客户消息列表点击",
        page_param: item,
      });
      
      this.$router.push({
        path: "ChatRoom",
        query: { ww_nick: item.ww_nick, title: item.ww_nick, is_in_list: item.is_in_list,buyer_openuid:item.buyer_openuid },
      });
    },
    // 跳到聊天详情图片页
    jump_ChatRoomImg() {
      this.$router.push({
        path: "ChatRoom",
        query: { ww_nick:'聊天详情',form:'CustomerMessageImg' },
      });
    },
    getData(params) {
      if (this.DataListDone || this.QUERY_DATA_ING) {
        this.isLoading = false;
        return false;
      }
      this.QUERY_DATA_ING = true // 用来记录当前是否正在请求 , 如果正在请求则不继续发送请求
      this.$store
        .dispatch("CustomerMessage/getMessagelist", params)
        .then((res) => {
          this.QUERY_DATA_ING = false // 返回后重置请求状态

          if (res.code == 1000 && res.data.list && res.data.list.length > 0) { // 有正常返回值
            this.$store.commit('CustomerMessage/offset_set', this.offset + 1)
            this.contentShow = true
          } else {
            if (res.data.list && res.data.list.length == 0) { // 数据返回的list
              // 如果返回的数据列表为空则提示数据到底了
              if (this.offset == 1) {
                    if(this.userInfo.is_boss == 1) {
                      DownScrollLoad.remove();
                      if(this.userInfo.is_overdue==0) {
                        this.contentShow = false
                        this.HasData = false
                      }else {
                        this.contentShow = false
                        this.noRootShow = true
                      }
                    }
              } else {
                this.DataListDone = true;
              }
            }else{ // 返回不正常数据
              this.HasData = false
            }
          }
          this.isLoading = false;
        });
        
    },
    DownScrollFN() {
      this.getData({ offset: this.offset, ww_nick: this.ww_nick });
    },
  },
  created(){
    let reload_one = sessionStorage.getItem('reload_one')
    if( reload_one == '1' ){
      sessionStorage.removeItem('reload_one');
      location.reload();
    }
  },
  mounted() {

    this.userInfo = this.$store.state.Public.AccountInfo
    // this.userInfo.is_boss = 0 
    if(this.userInfo.is_boss==0) {
      this.contentShow = false
      this.HasData = false
    }else {
      if( !(this.getMessagelist.list && this.getMessagelist.list.length>0) ){
        this.getData({ offset: this.offset, ww_nick: this.ww_nick });
      }else {
        this.contentShow = true
        setTimeout(()=>{
          document.getElementById('CustomerMessage').scrollTo(0, this.scrollTopValue)
        },0)

      }
    }
    
  },
  beforeDestroy() {
    DownScrollLoad.remove();
    window.removeEventListener("scroll", this.initHeight);
  },
};
</script>

<style lang="scss" src="./index.scss" scoped></style>
<style lang="scss">
#CustomerMessage .van-tabbar {
  background-color: #f7f7f7 !important;
  z-index: 20;
}
</style>